import React, { Component } from "react";

import { Button } from "./Button";
import { ThermocyclerTable } from "./ThermocyclerTable/ThermocyclerTable";
import { RunTable } from "./RunTable/RunTable";
import { StepEdit } from "./StepEdit/StepEdit";

import DeleteIcon from "../img/delete-icon.svg";
import HomeIcon from "../img/home-icon.svg";
import InsertIcon from "../img/insert-icon.svg";
import RunIcon from "../img/run-icon.svg";

import Toast from "../../../../../toast/Toast";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

export class ProgramOverview extends Component {

  // constructor(props) {
  //   super(props);
  //
  //   this.state = {
  //     volume: this.props.volume,
  //     lid: this.props.lid
  //   };
  // }

  makeToast = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px",
      }),
      progressClassName: css({
        background: color,
      }),
      position: "top-center",
      autoClose: 5000,
    });
  };

  save = () => {
    this.props.setSaved({
      id: this.props.id,
      saved: false,
    });
  };

  insert = () => {
    this.props.setDialog({
      id: this.props.id,
      dialog: "CHOOSE_TYPE",
    });
    this.props.setDialogDisplay({
      id: this.props.id,
      displayDialog: true,
    });
  };

  delete = () => {
    this.props.setDialog({
      id: this.props.id,
      dialog: "CONFIRM_DELETE",
    });
    this.props.setDialogDisplay({
      id: this.props.id,
      displayDialog: true,
    });
  };

  run = () => {
    if (this.props.open) {
      this.makeToast(
        "WARNING",
        "Close the lid before attempting to run",
        "Thermocycler lid is open!"
      );
      return;
    }

    if (this.props.sequence.length === 0) {
      return;
    }

    this.props.setModal({
      display: true,
      type: "THERMOCYCLER_RUN",
      size: "lg",
      connect: -1,
      data: {
        title: "Running the thermocycler.",
        type: "THERMOCYCLER_RUN",
        animation: "animations/Thermocycler.json",
        pIndex: 6,
        tIndex: 10
      }
    });

    // this.props.setDialog({
    //   id: this.props.id,
    //   dialog: "CONFIRM_RUN",
    // });
    // this.props.setDialogDisplay({
    //   id: this.props.id,
    //   displayDialog: true,
    // });
  };

  goHome = () => {
    this.props.setSection({
      id: this.props.id,
      section: "SPLASH_SCREEN",
    });
    // this.props.setInnerSection({
    //   id: this.props.id,
    //   innerSection: "THERMOCYCLER_TABLE",
    // });
  };

  getThermocyclerContent = () => {
    let content = null;

    switch (this.props.innerSection) {
      case "RUN_TABLE":
        content = (
          <RunTable
            id={this.props.id}
            sequence={this.props.sequence}
            updateSequence={this.props.updateSequence}
            updateSequenceTemp={this.props.updateSequenceTemp}
            updateSequenceTime={this.props.updateSequenceTime}
            updateSequenceRepeat={this.props.updateSequenceRepeat}
            deleteSequence={this.props.deleteSequence}
            setInnerSection={this.props.setInnerSection}
            editConnection={this.props.editConnection}
            setEditConnection={this.props.setEditConnection}
            currentTime={this.props.currentTime}
            running={this.props.running}
            setCurrentTime={this.props.setCurrentTime}
            setTotalTime={this.props.setTotalTime}
            totalTime={this.props.totalTime}
            setRunning={this.props.setRunning}
            setDurations={this.props.setDurations}
            durations={this.props.durations}
            setTotalElapsedTime={this.props.setTotalElapsedTime}
            totalElapsedTime={this.props.totalElapsedTime}
          />
        );
        break;
      case "THERMOCYCLER_TABLE":
        content = (
          <ThermocyclerTable
            id={this.props.id}
            sequence={this.props.sequence}
            insert={this.insert}
            updateSequence={this.props.updateSequence}
            updateSequenceTemp={this.props.updateSequenceTemp}
            updateSequenceTime={this.props.updateSequenceTime}
            updateSequenceRepeat={this.props.updateSequenceRepeat}
            deleteSequence={this.props.deleteSequence}
            setInnerSection={this.props.setInnerSection}
            editConnection={this.props.editConnection}
            setEditConnection={this.props.setEditConnection}
          />
        );
        break;
      case "STEP_EDIT":
        content = (
          <StepEdit
            id={this.props.id}
            sequence={this.props.sequence}
            updateSequence={this.props.updateSequence}

            updateSequenceTemp={this.props.updateSequenceTemp}
            updateSequenceTime={this.props.updateSequenceTime}
            updateSequenceRepeat={this.props.updateSequenceRepeat}

            deleteSequence={this.props.deleteSequence}
            setInnerSection={this.props.setInnerSection}
            editConnection={this.props.editConnection}
            setEditConnection={this.props.setEditConnection}
            setSaved={this.props.setSaved}
            saved={this.props.saved}
          />
        );
        break;

      default:
      // code block
    }

    return content;
  };

  buildHeader = () => {
    let header = null;

    if (this.props.innerSection === "THERMOCYCLER_TABLE") {
      header = (
        <div className="thermocycler-overview-header">
          <button
            onClick={() =>
              this.props.setSection({
                id: this.props.id,
                section: "SPLASH_SCREEN",
              })
            }
          >
            {"< Steps overview"}
          </button>
          <div className="header-input-group">
            <div className="header-input-volume">
              <span>Volume</span>
              <input
                type="number"
                value={this.props.volume}
                onChange={(e)=>{this.props.setVolume({
                  id: this.props.id,
                  volume: e.target.value
                })}}
              />
              <span>μl</span>
            </div>
            <div>
              <span style={{
                paddingRight: "20px",
                color: "white",
                lineHeight: "63px",
                fontSize: "40px"
              }}>|</span>
            </div>
            <div className="header-input-lid">
              <span>Lid</span>
              <input type="number"
                value={this.props.lid}
                onChange={(e)=>{this.props.setLid({
                  id: this.props.id,
                  lid: e.target.value
                })}}
              />
              <span>°C</span>
            </div>
          </div>
        </div>
      );
    } else if (this.props.innerSection === "STEP_EDIT") {
      header = (
        <div className="thermocycler-overview-header">
          <button
            onClick={() =>
              // this.props.setInnerSection({
              //   id: this.props.id,
              //   innerSection: "THERMOCYCLER_TABLE",
              // })
              this.props.setSection({
                id: this.props.id,
                section: "SPLASH_SCREEN",
              })
            }
          >
            {"< Program steps"}
          </button>
          <div className="header-input-group">
            <div className="header-input-volume">
              <span>Volume</span>
              <input type="text" disabled value={this.props.volume + "μl"} />
            </div>
            <div className="header-input-lid">
              <span>Lid</span>
              <input type="text" disabled value={this.props.lid + "°C"} />
            </div>
          </div>
        </div>
      );
    } else if (this.props.innerSection === "RUN_TABLE") {
      header = (
        <div className="thermocycler-overview-header">
          <button
            //style={{cursor: "initial"}}
            onClick={() =>
              this.props.setInnerSection({
                id: this.props.id,
                innerSection: "STEP_EDIT",
              })
            }
          >
            {"< Running"}
          </button>
          <div className="header-input-group">
            <div className="header-input-volume">
              <span style={{ fontSize: "16px" }}>Volume:</span>
              <span style={{ fontSize: "16px" }}>
                {this.props.volume + "μl"}
              </span>
            </div>
            <div className="header-input-lid">
              <span style={{ fontSize: "16px" }}> | </span>
              <span style={{ fontSize: "16px" }}>Lid:</span>
              <span style={{ fontSize: "16px" }}>{this.props.lid + "°C"}</span>
            </div>
          </div>
        </div>
      );
    }

    return header;
  };

  buildFooter = () => {
    let footer = null;

    if (this.props.innerSection !== "RUN_TABLE") {
      footer = (
        <div className="thermocycler-overview-footer">
          <Button onClick={this.goHome}>
            <img src={HomeIcon} alt="Home icon." />
            Home
          </Button>
          <Button onClick={this.insert}>
            <img src={InsertIcon} alt="Insert icon." />
            Insert
          </Button>
          <Button onClick={this.delete}>
            <img src={DeleteIcon} alt="Delete icon." />
            Delete
          </Button>
          <Button onClick={this.run}>
            <img src={RunIcon} alt="Run icon." />
            Run
          </Button>
        </div>
      );
    } else {
      footer = (
        <div className="thermocycler-run-footer">
          <div className="button-group">
            {/*<button
              onClick={() => {
                this.props.setCurrentTime(0);
                this.props.setRunning(true);
              }}
            >
              Restart
            </button>*/}
            <button
              onClick={() =>
                this.props.setRunning({
                  id: this.props.id,
                  running: !this.props.running,
                })
              }
            >
              {this.props.running ? "Stop" : "Resume"}
            </button>
          </div>
          <div className="time-info">
            <p>
              {
                this.convertSecondsToTimeString(this.props.totalElapsedTime) +
                " / " +
                this.convertSecondsToTimeString(this.props.totalTime)
              }
            </p>
          </div>
        </div>
      );
    }

    return footer;
  };

  convertSecondsToTimeString = (totalSeconds) => {
    const secNum = parseInt(totalSeconds.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [hours, minutes, seconds]
      .map((val) => (val < 10 ? `0${val}` : val))
      //.filter((val, index) => val !== "00" || index > 0)
      .join(":")
      //.replace(/^0/, "");
  };

  render() {
    return (
      <div className="thermocycler-overview-inner">
        {this.buildHeader()}
        <div className="thermocycler-overview-body">
          {this.getThermocyclerContent()}
        </div>
        {this.buildFooter()}
      </div>
    );
  }
}
